// ...existing code...
import { useContext } from "react";
import { AuthContext } from "../auth-context";
import IOList from "../widget/io-list";
import IOPanelWithNavigation from "../widget/io-panel-with-navigation";
import IOString from "../widget/io-string";
import IOText from "../widget/io-text";
import Panel from "../widget/panel";
import TwoColumns from "../widget/two-columns";
import type { ConsultOther, Patient } from "./_objects-patient";
import ConsultAbstractConclusion from "./blocs/consult-abstract-conclusion";
import ConsultAbstractIntroduction from "./blocs/consult-abstract-introduction";
import { type RelatedElementGeneratorProps } from "./patient-related-element-generator";

export default function ConsultOtherElement(
  props: { patient: Patient } & RelatedElementGeneratorProps<ConsultOther>
): React.ReactNode {
  const authenticationContext = useContext(AuthContext)!;

  return (
    <IOPanelWithNavigation<ConsultOther>
      {...props}
      key={`consult_other.${props.file.id}`}
      type="consult_other"
      apiRootUrl={`/api/patient/${props.patient.id}/consult_other`}
      restrictedForWrite="write"
      restrictedForUnlock="manage_archives"
      canBeLocked={true}
      basePath={`${props.parentPath}/consult_other`}
      header={<>{props.file.side}</>}
    >
      <ConsultAbstractIntroduction file={props.file} patient={props.patient} />
      <TwoColumns>
        <Panel label="Orthopedic data">
          <IOList
            name="side"
            value={props.file.side}
            list={authenticationContext.getList("Side")}
          />
          <IOString
            name="joints_or_bones_affected"
            label="Joints or Bones Affected"
            value={props.file.joints_or_bones_affected}
          />
          <IOString name="deformity" value={props.file.deformity} />
          <IOString
            name="articulation_mobility"
            value={props.file.articulation_mobility}
          />
          <IOString name="muscle_strength" value={props.file.muscle_strength} />
          <IOList
            name="pain"
            value={props.file.pain}
            list={authenticationContext.getList("Pain")}
          />
          <IOList
            name="walk"
            value={props.file.walk}
            list={authenticationContext.getList("WalkingCapacities")}
          />
          <IOString name="xray" label="XRay" value={props.file.xray} />
        </Panel>
        <Panel label="Orthopedic observations">
          <IOText name="examination_data" value={props.file.examination_data} />
        </Panel>
      </TwoColumns>
      <ConsultAbstractConclusion file={props.file} />
    </IOPanelWithNavigation>
  );
}
